// src/pages/pedidos/TaxaEntregaSearch.js
import React, { useEffect, useState, useRef } from 'react';
import { useTaxaEntrega } from '../../contexts/pedidos/TaxaEntregaContext';
import { FaSortUp, FaSortDown } from "react-icons/fa";

import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalHeader from '../../components/modalForm/ModalHeader';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalFooter from '../../components/modalForm/ModalFooter';
import ModalTable from '../../components/modalForm/ModalTable';
import LazyLoading from '../../components/modalForm/LazyLoading';
import { formatCurrency } from '../../utils/numberUtils';
import ModalSearchBar from '../../components/modalForm/ModalSearchBar';
import { ModalActionButton } from '../../components/modalForm/ModalActions';
import ModalSelectButton from '../../components/modalForm/ModalSelectButton';

const TaxaEntregaSearch = ({ show, onHide, onSelectTaxaEntrega }) => {
    const { taxasEntrega } = useTaxaEntrega();
    const [filter, setFilter] = useState('');

    const [sortField, setSortField] = useState('id');
    const [sortDirection, setSortDirection] = useState('asc');

    const inputRef = useRef(null);

    useEffect(() => {
        if (show) {
            setFilter('');

            if (inputRef.current) {
                inputRef.current.focus();
            }
        }
    }, [show]);

    if (!show) return null;

    const filteredTaxas = taxasEntrega.filter(taxa =>
        String(taxa?.limiteKm || '').toLowerCase().includes(filter.toLowerCase())
    );

    const sortedTaxas = filteredTaxas.sort((a, b) => {
        if (sortField === 'id') {
            return sortDirection === 'asc' ? a.id - b.id : b.id - a.id;
        } else if (sortField === 'limiteKm') {
            const descriptionA = a.limiteKm.toLowerCase();
            const descriptionB = b.limiteKm.toLowerCase();
            if (descriptionA < descriptionB) return sortDirection === 'asc' ? -1 : 1;
            if (descriptionA > descriptionB) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        }
        return 0;
    });

    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
    };

    const handleDoubleClick = (taxa) => {
        onSelectTaxaEntrega(taxa);
        onHide();
    };

    return (
        <ModalContainer show={show} variant="busca" onHide={onHide}>
            <ModalHeader title="Buscar Taxa de Entrega" onHide={onHide} />
            <ModalBody>
                <div className="mb-3">
                    <ModalSearchBar
                        inputRef={inputRef}
                        type="text"

                        placeholder="Filtrar por descrição..."
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    />
                </div>
                <LazyLoading items={sortedTaxas} resetKey={JSON.stringify([show, filter, sortField, sortDirection])}>
                {({ containerRef, handleScroll, visibleItems }) => (
                <ModalTable containerRef={containerRef} onContainerScroll={handleScroll}>
                    <thead>
                        <tr>
                            <th className="text-center align-middle" scope="col" style={{ width: '10%' }} aria-sort={sortField === 'id' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('id')} style={{ fontWeight: 'bold', background: 'none', border: 'none' }} tabIndex={0} type="button">
                                    Id
                                    {sortField === 'id' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-start align-middle" scope="col" style={{ width: '30%' }} aria-sort={sortField === 'limiteKm' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('limiteKm')} style={{ fontWeight: 'bold', background: 'none', border: 'none' }} tabIndex={0} type="button">
                                    Limite Km
                                    {sortField === 'limiteKm' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="align-middle" scope="col" style={{ width: '30%'}} tabIndex="-1">
                                Valor
                            </th>
                            <th className="text-center align-middle modal-select-column" scope="col" style={{ width: '20%' }}>Selecionar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {visibleItems.map((taxa) => (
                            <tr key={taxa.id} onDoubleClick={() => handleDoubleClick(taxa)}>
                                <td className="text-end align-middle">{taxa.id}</td>
                                <td className="text-end align-middle">{taxa?.limiteKm} Km</td>
                                <td className="text-end align-middle">{formatCurrency(taxa?.valor)}</td>
                                <td className="text-center align-middle modal-select-column">
                                    <ModalSelectButton className="btn btn-outline-secondary btn-sm" onClick={() => onSelectTaxaEntrega(taxa)} style={{ padding: '2px 6px' }} label={taxa?.limiteKm} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </ModalTable>
                )}
                </LazyLoading>
            </ModalBody>
            <ModalFooter>

                <ModalActionButton type="button" className="btn btn-secondary btn-sm" onClick={onHide} action="close">
                    Fechar
                </ModalActionButton>
            </ModalFooter>
        </ModalContainer>
    );
};

export default TaxaEntregaSearch;